import TemplatePage from "./TemplatePage";

const portalUrl = "https://members.innercircle.finance/mint";

const MembersPortalPage = () => {
  return (
    <TemplatePage showMenu={true}>
      <div className="flex flex-col items-center justify-center px-6 py-16 md:py-24">
        <div className="w-full max-w-3xl rounded-3xl border border-[#C1A875]/25 bg-[#0D1216]/80 p-8 md:p-12 text-center shadow-2xl">
          <div className="text-3xl md:text-5xl text-gold font-semibold mb-6">Members-only</div>
          <p className="text-white/90 text-base md:text-xl leading-8 mb-4">
            Public minting is no longer available.
          </p>
          <p className="text-white/70 text-sm md:text-lg leading-7 mb-8">
            Visit the Members Portal if you hold an ICF NFT.
          </p>
          <div className="flex flex-col md:flex-row items-center justify-center gap-4">
            <a
              href={portalUrl}
              target="_blank"
              rel="noreferrer"
              className="button-gold py-4 px-8 w-full md:w-auto text-center"
            >
              <span className="text-gold text-base">OPEN MEMBERS PORTAL</span>
            </a>
          </div>
        </div>
      </div>
    </TemplatePage>
  );
};

export default MembersPortalPage;
